import React from 'react';
import {Header, Breadcrumb, Icon, Label, Item,Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea, Image, Table,  Button, Grid,Input, Radio} from 'semantic-ui-react';
import CursoRow from './CursoRow';
import { Link } from "react-router-dom";
import {moneda, stringToDate} from '../../util/index';


const CursosProfesor=({ id, color, userInfo,  form, ajaxCallInProgress, datos, errors={}, strings, permisos, cursoCombo, cursos})=>{
    
    
	return (
        <Container >
        <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        <Segment basic>
        
           <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["descripcion"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["visualizar"]:""}</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    {cursos.length>0?
        
                        <Table.Body>
                        {cursos.map(renglon =>
								<CursoRow 
                                    key={renglon.id} 
									curso={renglon} 	
                                    color={color}
									form={form}
									permisos={permisos}
                                    />
				        )}	
                        </Table.Body>
                    :
                    ""
                    }
                </Table>    
           
        
        </Segment>
        </Dimmer.Dimmable>
        </Container>
	);
};



export default CursosProfesor;